import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import { SnackbarProvider } from 'notistack';
import theme from './theme';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import Productos from './pages/inventario/Productos';
import ProductoForm from './pages/inventario/ProductoForm';
import Transferencias from './pages/inventario/Transferencias';
import AjusteInventarioForm from './pages/inventario/AjusteInventarioForm';
import Ramos from './pages/inventario/Ramos';
import RamoForm from './pages/inventario/RamoForm';
import Lineas from './pages/inventario/Lineas';
import LineaForm from './pages/inventario/LineaForm';
import Clases from './pages/inventario/Clases';
import ClaseForm from './pages/inventario/ClaseForm';
import Devoluciones from './pages/inventario/Devoluciones';
import Produccion from './pages/inventario/Produccion';
import Picking from './pages/inventario/Picking';
import ConteoStock from './pages/inventario/ConteoStock';
import Recibos from './components/Tesoreria/Recibos';
import NuevoRecibo from './components/Tesoreria/NuevoRecibo';
import OrdenPago from './components/Tesoreria/OrdenPago';
import NuevaOrdenPago from './components/Tesoreria/NuevaOrdenPago';
import MovimientosVarios from './components/Tesoreria/MovimientosVarios';
import MovimientosBancarios from './components/Tesoreria/MovimientosBancarios';
import NuevoMovimientoCaja from './components/Tesoreria/NuevoMovimientoCaja';
import Bancos from './pages/tesoreria/Bancos';
import BancoForm from './pages/tesoreria/BancoForm';
import Carteras from './pages/tesoreria/Carteras';
import CarteraForm from './pages/tesoreria/CarteraForm';
import GruposMcp from './pages/tesoreria/GruposMcp';
import GrupoMcpForm from './pages/tesoreria/GrupoMcpForm';
import MarcasTarjetas from './pages/tesoreria/MarcasTarjetas';
import MarcaTarjetaForm from './pages/tesoreria/MarcaTarjetaForm';
import MovimientosCaja from './pages/tesoreria/MovimientosCaja';
import TesoreriaInformes from './pages/tesoreria/Informes';
import ChequesTercero from './pages/tesoreria/ChequesTercero';
import ChequesTercerosCartera from './pages/tesoreria/ChequesTercerosCartera';
import ChequesPropios from './pages/tesoreria/ChequesPropios';
import ChequesPropiosPendientesAcreditar from './pages/tesoreria/ChequesPropiosPendientesAcreditar';
import Disponibilidades from './pages/tesoreria/Disponibilidades';
import MovimientosCarteras from './pages/tesoreria/MovimientosCarteras';
import TesoreriaTransferencias from './pages/tesoreria/Transferencias';
import ConsultasPage from './pages/ConsultasPage';
import StockPorDeposito from './pages/inventario/StockPorDeposito';
import Informes from './pages/inventario/Informes';
import MovimientosStock from './pages/inventario/MovimientosStock';
import Clientes from './pages/Clientes';
import ClienteForm from './pages/ClienteForm';
import Proveedores from './pages/inventario/Proveedores';
import ProveedorForm from './pages/inventario/ProveedorForm';
import Pedidos from './pages/pedidoventa/Pedidos';
import PedidosVenta from './pages/pedidoventa/index';
import Cotizaciones from './pages/cotizacionventa/Cotizaciones';
import CotizacionesVenta from './pages/cotizacionventa/index';
import NuevaFacturaVenta from './pages/facturaventa/index';
import VentasInformes from './pages/ventas/Informes';
import CuentasPorCobrar from './pages/ventas/CuentasPorCobrar';
import ComposicionSaldo from './pages/ventas/ComposicionSaldo';
import Facturas from './pages/ventas/Facturas';
import NotasCredito from './pages/ventas/NotasCredito';
import LibroIvaVentas from './pages/ventas/LibroIvaVentas';
import ComprasInformes from './pages/compras/Informes';
import CuentasPorPagar from './pages/compras/CuentasPorPagar';
import ResumenCuenta from './pages/compras/ResumenCuenta';
import LibroIvaCompras from './pages/compras/LibroIvaCompras';

import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { buildInfo } from './config/buildInfo';

const App: React.FC = () => {

  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showInstallButton, setShowInstallButton] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const [waitingWorker, setWaitingWorker] = useState<ServiceWorkerRegistration | null>(null);
    const [postUpdateVersion, setPostUpdateVersion] = useState<string | null>(null);
    const [isUpdating, setIsUpdating] = useState(false);

useEffect(() => {
        const handleBeforeInstallPrompt = (e: any) => {
            e.preventDefault(); // Previene que el navegador muestre el prompt automáticamente
            setDeferredPrompt(e);
            setShowInstallButton(true);
            setSnackbarOpen(true); // Mostrar Snackbar con botón
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = async () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            const choiceResult = await deferredPrompt.userChoice;
            console.log(`User response to the install prompt: ${choiceResult.outcome}`);
            setDeferredPrompt(null);
            setShowInstallButton(false);
            setSnackbarOpen(false);
        }
    };

    // Registrar service worker y verificar actualizaciones periódicamente
    useEffect(() => {
      // Verificar si hay un flag de actualización pendiente
      const updatingFlag = localStorage.getItem('appIsUpdating');
      if (updatingFlag) {
        setIsUpdating(true);
        // Limpiar el flag después de un breve delay para permitir que la actualización se complete
        setTimeout(() => {
          localStorage.removeItem('appIsUpdating');
          setIsUpdating(false);
        }, 3000);
      }

      const handleUpdate = (registration: ServiceWorkerRegistration) => {
        // Solo mostrar el mensaje si no estamos en proceso de actualización
        // Verificar el flag en tiempo real, no depender del closure
        const currentlyUpdating = localStorage.getItem('appIsUpdating');
        if (!currentlyUpdating) {
          setUpdateAvailable(true);
          setWaitingWorker(registration);
        }
      };

      serviceWorkerRegistration.register({
        onUpdate: handleUpdate,
        onSuccess: () => {
          console.log('Service Worker registrado correctamente');
        }
      });

      // Verificar si ya hay un service worker esperando al cargar
      // Esperar un poco para que se limpie el flag si existe
      setTimeout(() => {
        const currentlyUpdating = localStorage.getItem('appIsUpdating');
        if ('serviceWorker' in navigator && !currentlyUpdating) {
          navigator.serviceWorker.ready.then((registration) => {
            // Solo mostrar si realmente hay uno esperando Y no estamos actualizando
            if (registration.waiting && !localStorage.getItem('appIsUpdating')) {
              setUpdateAvailable(true);
              setWaitingWorker(registration);
            }
          });
        }
      }, 1000);

      // Escuchar eventos de actualización del service worker
      if ('serviceWorker' in navigator) {
        const controllerChangeHandler = () => {
          // El service worker cambió, verificar si hay uno esperando
          // Pero solo si no estamos en proceso de actualización
          const currentlyUpdating = localStorage.getItem('appIsUpdating');
          if (!currentlyUpdating) {
            navigator.serviceWorker.ready.then((registration) => {
              if (registration.waiting && !localStorage.getItem('appIsUpdating')) {
                setUpdateAvailable(true);
                setWaitingWorker(registration);
              }
            });
          }
        };
        
        navigator.serviceWorker.addEventListener('controllerchange', controllerChangeHandler);
        
        return () => {
          navigator.serviceWorker.removeEventListener('controllerchange', controllerChangeHandler);
        };
      }

      // Verificar actualizaciones periódicamente (cada 2 minutos)
      const checkInterval = setInterval(() => {
        // Solo verificar si no estamos en proceso de actualización
        const currentlyUpdating = localStorage.getItem('appIsUpdating');
        if (!currentlyUpdating) {
          serviceWorkerRegistration.checkForUpdates();
        }
      }, 2 * 60 * 1000); // 2 minutos

      return () => {
        clearInterval(checkInterval);
      };
    }, []);

    useEffect(() => {
      const updatedVersion = localStorage.getItem('appUpdatedToVersion');
      if (updatedVersion) {
        setPostUpdateVersion(updatedVersion);
        localStorage.removeItem('appUpdatedToVersion');
      }
    }, []);

    const handleUpdateClick = async () => {
      // Marcar que estamos actualizando para evitar mostrar el mensaje nuevamente
      localStorage.setItem('appIsUpdating', 'true');
      setIsUpdating(true);
      setUpdateAvailable(false); // Ocultar el mensaje inmediatamente
      
      localStorage.setItem(
        'appUpdatedToVersion',
        `v${buildInfo.version} (build ${buildInfo.buildNumber})`
      );
      
      if (waitingWorker) {
        // Enviar mensaje al service worker para que se active
        waitingWorker.waiting?.postMessage({ type: 'SKIP_WAITING' });
        // Esperar un momento y luego recargar
        setTimeout(() => {
          window.location.reload();
        }, 100);
      } else {
        // Forzar recarga sin caché - limpiar todo
        try {
          // Desregistrar todos los service workers
          if ('serviceWorker' in navigator) {
            const registrations = await navigator.serviceWorker.getRegistrations();
            await Promise.all(registrations.map(reg => reg.unregister()));
          }
          
          // Limpiar todos los caches
          if ('caches' in window) {
            const cacheNames = await caches.keys();
            await Promise.all(cacheNames.map(name => caches.delete(name)));
          }
        } catch (error) {
          console.error('Error al limpiar cache:', error);
        }
        
        // Recargar sin cache
        window.location.reload();
      }
    };

    const handlePostUpdateClose = () => {
      setPostUpdateVersion(null);
    };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider maxSnack={3}>
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Layout />
                  </PrivateRoute>
                }
              >
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="tesoreria">
                  <Route path="recibos" element={<Recibos />} />
                  <Route path="recibos/nuevo" element={<NuevoRecibo />} />
                  <Route path="orden-pago" element={<OrdenPago />} />
                  <Route path="orden-pago/nuevo" element={<NuevaOrdenPago />} />
                  <Route path="movimientos-varios" element={<MovimientosVarios />} />
                  <Route path="movimientos-varios/nuevo" element={<NuevoMovimientoCaja />} />
                  <Route path="movimientos-bancarios" element={<MovimientosBancarios />} />
                  <Route path="bancos" element={<Bancos />} />
                  <Route path="bancos/nuevo" element={<BancoForm />} />
                  <Route path="bancos/:nroBanco" element={<BancoForm />} />
                  <Route path="carteras" element={<Carteras />} />
                  <Route path="carteras/nuevo" element={<CarteraForm />} />
                  <Route path="carteras/:nroBanco" element={<CarteraForm />} />
                  <Route path="grupos-mcp" element={<GruposMcp />} />
                  <Route path="grupos-mcp/nuevo" element={<GrupoMcpForm />} />
                  <Route path="grupos-mcp/:grupoMcp" element={<GrupoMcpForm />} />
                  <Route path="tarjetas" element={<MarcasTarjetas />} />
                  <Route path="tarjetas/nuevo" element={<MarcaTarjetaForm />} />
                  <Route path="tarjetas/:codigoMarca" element={<MarcaTarjetaForm />} />
                  <Route path="movimientos-caja" element={<MovimientosCaja />} />
                  <Route path="disponibilidades" element={<Disponibilidades />} />
                  <Route path="transferencias" element={<TesoreriaTransferencias />} />
                  <Route path="informes" element={<TesoreriaInformes />} />
                  <Route path="informes/cheques-tercero" element={<ChequesTercero />} />
                  <Route path="informes/cheques-terceros-cartera" element={<ChequesTercerosCartera />} />
                  <Route path="informes/cheques-propios" element={<ChequesPropios />} />
                  <Route path="informes/cheques-propios-pendientes-acreditar" element={<ChequesPropiosPendientesAcreditar />} />
                  <Route path="informes/movimientos-carteras" element={<MovimientosCarteras />} />
                </Route>
                <Route path="inventario">
                  <Route path="productos" element={<Productos />} />
                  <Route path="productos/nuevo" element={<ProductoForm />} />
                  <Route path="productos/:codigoArticulo" element={<ProductoForm />} />
                  <Route path="transferencias" element={<Transferencias />} />
                  <Route path="transferencias/nuevo" element={<AjusteInventarioForm />} />
                  <Route path="transferencias/:nroFormulario" element={<AjusteInventarioForm />} />
                  <Route path="ramos" element={<Ramos />} />
                  <Route path="ramos/nuevo" element={<RamoForm />} />
                  <Route path="ramos/:codigoRamo" element={<RamoForm />} />
                  <Route path="lineas" element={<Lineas />} />
                  <Route path="lineas/nuevo" element={<LineaForm />} />
                  <Route path="lineas/:codigoLinea" element={<LineaForm />} />
                  <Route path="clases" element={<Clases />} />
                  <Route path="clases/nuevo" element={<ClaseForm />} />
                  <Route path="clases/:codigoClase" element={<ClaseForm />} />
                  <Route path="devoluciones" element={<Devoluciones />} />
                  <Route path="produccion" element={<Produccion />} />
                  <Route path="picking" element={<Picking />} />
                  <Route path="conteo" element={<ConteoStock />} />
                  <Route path="informes" element={<Informes />} />
                  <Route path="informes/stock-deposito" element={<StockPorDeposito />} />
                  <Route path="informes/movimientos-stock" element={<MovimientosStock />} />
                </Route>
                <Route path="compras">
                  <Route path="proveedores" element={<Proveedores />} />
                  <Route path="proveedores/nuevo" element={<ProveedorForm />} />
                  <Route path="proveedores/:nroProveedor" element={<ProveedorForm />} />
                  <Route path="informes" element={<ComprasInformes />} />
                  <Route path="informes/cuentas-pagar" element={<CuentasPorPagar />} />
                  <Route path="informes/resumen-cuenta" element={<ResumenCuenta />} />
                  <Route path="informes/resumen-cuenta/:nroProveedor" element={<ResumenCuenta />} />
                  <Route path="informes/libro-iva-compras" element={<LibroIvaCompras />} />
                </Route>
                <Route path="ventas">
                  <Route path="clientes" element={<Clientes />} />
                  <Route path="clientes/nuevo" element={<ClienteForm />} />
                  <Route path="clientes/:nroCliente" element={<ClienteForm />} />
                  <Route path="pedidos" element={<Pedidos />} />
                  <Route path="pedidos/nuevo" element={<PedidosVenta />} />
                  <Route path="pedidos/:pedidoId/editar" element={<PedidosVenta />} />
                  <Route path="pedidos/:pedidoId/ver" element={<PedidosVenta />} />
                  <Route path="cotizaciones" element={<Cotizaciones />} />
                  <Route path="cotizaciones/nuevo" element={<CotizacionesVenta />} />
                  <Route path="cotizaciones/:cotizacionId/editar" element={<CotizacionesVenta />} />
                  <Route path="cotizaciones/:cotizacionId/ver" element={<CotizacionesVenta />} />
                  <Route path="facturas" element={<Facturas />} />
                  <Route path="facturas/nuevo" element={<NuevaFacturaVenta />} />
                  <Route path="notas-credito" element={<NotasCredito />} />
                  <Route path="informes" element={<VentasInformes />} />
                  <Route path="informes/cuentas-cobrar" element={<CuentasPorCobrar />} />
                  <Route path="informes/composicion-saldo" element={<ComposicionSaldo />} />
                  <Route path="informes/composicion-saldo/:nroCliente" element={<ComposicionSaldo />} />
                  <Route path="informes/libro-iva-ventas" element={<LibroIvaVentas />} />
                </Route>
                <Route path="consultas" element={<ConsultasPage />} />
              </Route>
            </Routes>
          </Router>
          {/* Snackbar con botón de instalación */}
          <Snackbar
                open={snackbarOpen}
                message="¿Querés instalar esta app?"
                action={
                    <Button color="secondary" size="small" onClick={handleInstallClick}>
                        Instalar
                    </Button>
                }
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                onClose={() => setSnackbarOpen(false)}
            />
          {/* Snackbar con botón de actualización */}
          <Snackbar
                open={updateAvailable && !isUpdating}
                message="Hay una nueva versión disponible"
                action={
                    <Button color="primary" size="small" onClick={handleUpdateClick}>
                        Actualizar
                    </Button>
                }
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                onClose={() => {}}
            />
          {/* Snackbar informativo post-actualización */}
          <Snackbar
                open={Boolean(postUpdateVersion)}
                message={`Aplicación actualizada a ${postUpdateVersion}`}
                autoHideDuration={6000}
                onClose={handlePostUpdateClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            />
        </AuthProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
};

export default App; 